//
// Imports
//

import * as FritterApiUtilities from "@donutteam/fritter-api-utilities";
import { z } from "zod";

import * as ProfileSchemaLib from "../../../../_shared/libs/schemas/Profile.js";

//
// Types
//

export type RequestBody = z.infer<typeof RequestBodySchema>;

export const RequestBodySchema = z.object(
	{
		aboutSyntax: ProfileSchemaLib.AboutSyntaxSchema.nullish(),
		aboutText: ProfileSchemaLib.AboutTextSchema.nullish(),
		color: ProfileSchemaLib.ColorSchema.nullish(),
	});

export type ResponseBody = z.infer<typeof ResponseBodySchema>;

export const ResponseBodySchema = z.union(
	[
		FritterApiUtilities.SuccessResponseBodySchema,

		FritterApiUtilities.ErrorResponseBodySchema,
	]);